<div>
  <div class="container">
    <div class="header page">
      <div class="pt-2 pb-2">
        <h1>Личный кабинет</h1>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="page">
      <form [formGroup]='tournamentCreationInitialForm'>
        <div>
          <div class="standardInputSectionStyle">
            <label
              for='tournamentName'
              class="inputLabelStyle"
            >
              Название турнира
            </label>
            <input
              id='tournamentName'
              type='text'
              formControlName='tournamentTitle'
              [placeholder]="expectedToBeFilled"
            >
          </div>
          <app-validation-error
            [touched]="_tournamentTitleField.touched"
            [isErroneous] = "_tournamentTitleField.errors?.required"
            fieldLabelName="Название турнира"
            requiredAction="обязательно к заполнению"
          >
          </app-validation-error>
          <div class="standardInputSectionStyle">
            <label
              for='tournamentScheduledDate'
              class="inputLabelStyle"
            >
              Дата и время начала турнира
            </label>
            <div
              class="dateTimePickerSpecialStyle"
            >
              <input
                type='text'
                ngbDatepicker
                #d1='ngbDatepicker'
                id='tournamentScheduledDate'
                [(ngModel)]="tournamentScheduledDate"
                (click)="d1.toggle(); datePickerOpened = true;"
                [readonly]="true"
                formControlName="tournamentScheduledDateField"
                (closed)="datePickerOpened = false"
                [placeholder]="expectedToBeFilled"
              >
              <div
                class="dateTimePickerStyle"
              >
                <ngb-timepicker
                  id='timepicker1'
                  [spinners]="false"
                  [size]="'small'"
                  [(ngModel)]="tournamentScheduledTime"
                  [formControl]="_tournamentScheduledTimeField"
                >
                </ngb-timepicker>
              </div>
              <div
                class="timePickerExpectedToBeFilled"
              >
                ({{expectedToBeFilled.toLowerCase()}})
              </div>
            </div>
          </div>
          <app-validation-error
            [touched]="_tournamentScheduledDateField.touched && !datePickerOpened"
            [isErroneous]="_tournamentScheduledDateField.errors?.required"
            fieldLabelName="Дата начала турнира"
            requiredAction="обязательна к заполнению"
          >
          </app-validation-error>
          <app-validation-error
            [touched]="_tournamentScheduledTimeField.touched"
            [isErroneous]="_tournamentScheduledTimeField.errors?.required"
            fieldLabelName="Время начала турнира"
            requiredAction="обязательно к заполнению"
          >
          </app-validation-error>
          <div class="standardInputSectionStyle">
            <label
              for='tournamentEndAtDate'
              class="inputLabelStyle"
            >
              Дата и время завершения турнира
            </label>
            <div
              class="dateTimePickerSpecialStyle"
            >
              <input
                type='text'
                ngbDatepicker
                #d2='ngbDatepicker'
                id='tournamentEndAtDate'
                [(ngModel)]="tournamentEndAtDate"
                (click)="d2.toggle(); datePickerOpened = true;"
                [readonly]="true"
                formControlName="tournamentEndAtDateField"
                (closed)="datePickerOpened = false"
                [placeholder]="expectedToBeFilled"
              >
              <div
                class="dateTimePickerStyle"
              >
                <ngb-timepicker
                  id='timepicker2'
                  [spinners]="false"
                  [size]="'small'"
                  [(ngModel)]="tournamentEndAtTime"
                  [formControl]="_tournamentEndAtTimeField"
                >
                </ngb-timepicker>
              </div>
              <div
                class="timePickerExpectedToBeFilled"
              >
                ({{expectedToBeFilled.toLowerCase()}})
              </div>
            </div>
          </div>
          <app-validation-error
            [touched]="_tournamentEndAtDateField.touched && !datePickerOpened"
            [isErroneous]="_tournamentEndAtDateField.errors?.required"
            fieldLabelName="Дата завершения турнира"
            requiredAction="обязательна к заполнению"
          >
          </app-validation-error>
          <app-validation-error
            [touched]="_tournamentEndAtTimeField.touched"
            [isErroneous]="_tournamentEndAtTimeField.errors?.required"
            fieldLabelName="Время завершения турнира"
            requiredAction="обязательно к заполнению"
          >
          </app-validation-error>
          <div class="standardInputSectionStyle">
            <label
              for='tournamentVenue'
              class="inputLabelStyle"
            >
              Место проведения турнира
            </label>
            <input
              id='tournamentVenue'
              type='text'
              formControlName='tournamentVenue'
              [ngbTypeahead]='searchVenue'
              [inputFormatter]='venueInputFormatter'
              [resultFormatter]='venueResultFormatter'
              (focus)='subjectsList[0].focus.next($any($event).target.value)'
              (click)='subjectsList[0].click.next($any($event).target.value)'
              #instance='ngbTypeahead'
              [placeholder]="expectedToBeFilled"
            >
          </div>
          <app-validation-error
            [touched]="_tournamentVenueField.touched"
            [isErroneous]="_tournamentVenueField.errors?.required"
            fieldLabelName="Место проведения турнира"
            requiredAction="обязятельно к заполнению"
          >
          </app-validation-error>

          <div class="standardInputSectionStyle">
            <label
              for='format'
              class="inputLabelStyle"
            >
              Формат
            </label>
            <input
              id='format'
              type='text'
              formControlName='tournamentFormat'
              [ngbTypeahead]='searchFormat'
              [inputFormatter]='venueInputFormatter'
              [resultFormatter]='venueResultFormatter'
              (focus)='subjectsList[3].focus.next($any($event).target.value)'
              (click)='subjectsList[3].click.next($any($event).target.value)'
              #instance='ngbTypeahead'
              [placeholder]="expectedToBeFilled"
            >
          </div>
          <app-validation-error
            [touched]="_tournamentFormatField.touched"
            [isErroneous]="_tournamentFormatField.errors?.required"
            fieldLabelName="Формат"
            requiredAction="обязателен к указанию"
          >
          </app-validation-error>

          <div class="standardInputSectionStyle">
            <label
              for='category'
              class="inputLabelStyle"
            >
              Категория
            </label>
            <input
              id='category'
              type='text'
              formControlName='tournamentCategory'
              [ngbTypeahead]='searchCategory'
              [inputFormatter]='venueInputFormatter'
              [resultFormatter]='venueResultFormatter'
              (focus)='subjectsList[2].focus.next($any($event).target.value)'
              (click)='subjectsList[2].click.next($any($event).target.value)'
              #instance='ngbTypeahead'
              [placeholder]="expectedToBeFilled"
            >
          </div>
          <app-validation-error
            [touched]="_tournamentCategoryField.touched"
            [isErroneous]="_tournamentCategoryField.errors?.required"
            fieldLabelName="Категория"
            requiredAction="обязательна к указанию"
          >
          </app-validation-error>


          <div class="standardInputSectionStyle">
            <label
              for='gameType'
              class="inputLabelStyle"
            >
              Игра
            </label>
            <input
              id='gameType'
              type='text'
              formControlName='tournamentGameType'
              [ngbTypeahead]='searchGameType'
              [inputFormatter]='venueInputFormatter'
              [resultFormatter]='venueResultFormatter'
              (focus)='subjectsList[1].focus.next($any($event).target.value)'
              (click)='subjectsList[1].click.next($any($event).target.value)'
              #instance='ngbTypeahead'
              [placeholder]="expectedToBeFilled"
            >
          </div>
          <app-validation-error
            [touched]="_tournamentGameTypeField.touched"
            [isErroneous]="_tournamentGameTypeField.errors?.required"
            fieldLabelName="Вид игры"
            requiredAction="обязателен к указанию"
          >
          </app-validation-error>
          <div class="standardInputSectionStyle">
            <label
              for='tournamentRegulationsPDF'
              class="inputLabelStyle"
            >
              Регламент (PDF)
            </label>
            <input
              id='tournamentRegulationsPDF'
              type='file'
              accept='application/pdf'
              (change)="readAndEncodeRegulationsPDF($event.target)"
              [placeholder]="expectedToBeFilled"
            >
          </div>
          <app-judge-search>
          </app-judge-search>
        </div>
        <div class="buttonSectionStyle">
          <button
            id="create_tournament_button_id"
            type="submit"
            [ngClass]="createButtonStyle()"
            (click)="createTournament()"
          >
            Создать
          </button>
          <button
            class="exitButtonStyle"
            (click)="logOutAndRedirect()"
          >
            Выйти
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

